import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../constants";
import { apiFetch } from "../../utils/apiFetch";

// Səviyyə rəngləri: 1-Yaxşı (Yaşıl), 2-Orta (Sarı), 3-Pis (Qırmızı)
const LEVEL_CONFIG = {
  1: {
    color: "#059669",
    bg: "rgba(5, 150, 105, 0.1)",
    icon: "bi-check-circle-fill",
    label: "Yaxşı",
  },
  2: {
    color: "#f59e0b",
    bg: "rgba(245, 158, 11, 0.1)",
    icon: "bi-info-circle-fill",
    label: "Orta",
  },
  3: {
    color: "#ef4444",
    bg: "rgba(239, 68, 68, 0.1)",
    icon: "bi-exclamation-triangle-fill",
    label: "Zəif",
  },
};

const FILTER_OPTIONS = [
  { label: "Hamısı", value: "all", color: "#6b7280" },
  { label: "Yaxşı", value: 1, color: "#059669" },
  { label: "Orta", value: 2, color: "#f59e0b" },
  { label: "Zəif", value: 3, color: "#ef4444" },
];

export default function SelectionPanelForMarks({
  onSelect,
  disabledNotes = [],
}) {
  const [categories, setCategories] = useState([]);
  const [selectedCatId, setSelectedCatId] = useState("");
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [templatesLoading, setTemplatesLoading] = useState(false);
  const [filterLevel, setFilterLevel] = useState("all");
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      try {
        const [res] = await Promise.all([
          apiFetch(BASE_URL + "/student-mark-note-categories"),
          new Promise((r) => setTimeout(r, 600)),
        ]);
        const data = await res.json();
        const cats = data.categories || [];
        setCategories(cats);
        if (cats.length > 0) setSelectedCatId(String(cats[0].id));
      } catch (err) {
        console.error("Kateqoriya xətası:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    if (!selectedCatId) return;
    const fetchTemplates = async () => {
      setTemplatesLoading(true);
      try {
        const [res] = await Promise.all([
          apiFetch(BASE_URL + `/student-note-list-templates/category/${selectedCatId}`),
          new Promise((r) => setTimeout(r, 600)),
        ]);
        const data = await res.json();
        if (data && data.notes) {
          setTemplates(data.notes);
        } else if (Array.isArray(data)) {
          setTemplates(data);
        } else {
          setTemplates([]);
        }
      } catch (err) {
        console.error("Şablon xətası:", err);
        setTemplates([]);
      } finally {
        setTemplatesLoading(false);
      }
    };
    fetchTemplates();
  }, [selectedCatId]);

  const filteredTemplates = templates.filter((item) => {
    const levelMatch =
      filterLevel === "all" || Number(item.noteLevel) === Number(filterLevel);
    const searchMatch =
      searchText.trim() === "" ||
      (item.name &&
        item.name.toLowerCase().includes(searchText.trim().toLowerCase()));
    return levelMatch && searchMatch;
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 16,
        width: "100%",
        height: "510px",
      }}
    >
      {/* Kateqoriya Seçimi */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 6,
          height: "60px",
        }}
      >
        <label
          style={{
            fontSize: 10,
            fontWeight: 700,
            color: "var(--text-muted)",
            textTransform: "uppercase",
          }}
        >
          Kateqoriya
        </label>
        {loading ? (
          <div
            style={{
              height: 38,
              background: "var(--bg-elevated)",
              borderRadius: 8,
              animation: "pulse 1.5s infinite",
            }}
          />
        ) : (
          <select
            value={selectedCatId}
            onChange={(e) => setSelectedCatId(e.target.value)}
            className="modern-select"
            style={{
              width: "100%",
              border: "1px solid var(--border)",
              borderRadius: 8,
              padding: "8px 12px",
              fontSize: 13,
              background: "var(--bg-elevated)",
              color: "var(--text-primary)",
            }}
          >
            {categories.map((cat) => (
              <option key={cat.id} value={String(cat.id)}>
                {cat.name}
              </option>
            ))}
          </select>
        )}
      </div>

      {/* Səviyyə Filteri */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 6,
          height: "60px",
        }}
      >
        <label
          style={{
            fontSize: 10,
            fontWeight: 700,
            color: "var(--text-muted)",
            textTransform: "uppercase",
          }}
        >
          Süzgəc
        </label>
        <div style={{ display: "flex", gap: 8 }}>
          {FILTER_OPTIONS.map((opt) => (
            <button
              type="button"
              key={opt.value}
              onClick={() => setFilterLevel(opt.value)}
              style={{
                flex: 1,
                borderRadius: 8,
                padding: "6px 4px",
                fontSize: 11,
                fontWeight: 600,
                cursor: "pointer",
                background:
                  filterLevel === opt.value ? opt.color : "var(--bg-elevated)",
                color: filterLevel === opt.value ? "#fff" : "var(--text-muted)",
                // Border burada tək istifadə olundu:
                border: `1px solid ${filterLevel === opt.value ? opt.color : "var(--border)"}`,
                transition: "all 0.2s",
              }}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>

      {/* Axtarış */}
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        <label
          style={{
            fontSize: 10,
            fontWeight: 700,
            color: "var(--text-muted)",
            textTransform: "uppercase",
          }}
        >
          Axtarış
        </label>
        <div style={{ position: "relative" }}>
          <i
            className="bi bi-search"
            style={{
              position: "absolute",
              left: 10,
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: 12,
              color: "var(--text-muted)",
              pointerEvents: "none",
            }}
          />
          <input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Fikir axtarın..."
            style={{
              width: "100%",
              border: "1px solid var(--border)",
              borderRadius: 8,
              padding: "7px 12px 7px 30px",
              fontSize: 13,
              background: "var(--bg-elevated)",
              color: "var(--text-primary)",
              outline: "none",
            }}
            onFocus={(e) => (e.target.style.borderColor = "var(--color-primary)")}
            onBlur={(e) => (e.target.style.borderColor = "var(--border)")}
          />
          {searchText && (
            <button
              type="button"
              onClick={() => setSearchText("")}
              style={{
                position: "absolute",
                right: 8,
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "var(--text-muted)",
                fontSize: 14,
                padding: 0,
                lineHeight: 1,
              }}
            >
              <i className="bi bi-x" />
            </button>
          )}
        </div>
      </div>

      {/* Şablon Siyahısı */}
      <div
        className="custom-scrollbar"
        style={{
          height: "280px",
          overflowY: "auto",
          border: "1px solid var(--border)",
          borderRadius: 12,
          background: "var(--bg-base)",
        }}
      >
        {templatesLoading ? (
          [1, 2, 3, 4, 5].map((i) => (
            <div
              key={i}
              style={{
                padding: "12px 16px",
                display: "flex",
                gap: 12,
                alignItems: "center",
                borderBottom: "1px solid var(--border)",
              }}
            >
              <div
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: "50%",
                  background: "var(--bg-elevated)",
                  animation: "pulse 1.5s infinite",
                }}
              />
              <div
                style={{
                  width: "70%",
                  height: 12,
                  background: "var(--bg-elevated)",
                  borderRadius: 4,
                  animation: "pulse 1.5s infinite",
                }}
              />
            </div>
          ))
        ) : filteredTemplates.length > 0 ? (
          filteredTemplates.map((item, idx) => {
            const config = LEVEL_CONFIG[item.noteLevel] || LEVEL_CONFIG[2];
            const isDisabled = disabledNotes.includes(item.name);
            return (
              <div
                key={item.id}
                onClick={() => !isDisabled && onSelect(item)}
                className={isDisabled ? "" : "list-item-hover"}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "12px 16px",
                  cursor: isDisabled ? "not-allowed" : "pointer",
                  borderBottom:
                    idx < filteredTemplates.length - 1
                      ? "1px solid var(--border)"
                      : "none",
                  opacity: isDisabled ? 0.55 : 1,
                  background: isDisabled ? "rgba(107,114,128,0.04)" : undefined,
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div
                    style={{
                      width: 28,
                      height: 28,
                      borderRadius: "50%",
                      background: isDisabled
                        ? "rgba(107,114,128,0.1)"
                        : config.bg,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i
                      className={`bi ${isDisabled ? "bi-slash-circle" : config.icon}`}
                      style={{
                        color: isDisabled ? "#9ca3af" : config.color,
                        fontSize: 14,
                      }}
                    ></i>
                  </div>
                  <div
                    style={{ display: "flex", flexDirection: "column", gap: 2 }}
                  >
                    <span
                      style={{
                        fontSize: 13,
                        color: isDisabled ? "#9ca3af" : "var(--text-primary)",
                        fontWeight: 500,
                      }}
                    >
                      {item.name}
                    </span>
                    {isDisabled && (
                      <span
                        style={{
                          fontSize: 10,
                          color: "#9ca3af",
                          fontWeight: 600,
                        }}
                      >
                        Ötən dərs seçilib
                      </span>
                    )}
                  </div>
                </div>
                {!isDisabled && (
                  <i
                    className="bi bi-chevron-right"
                    style={{
                      fontSize: 12,
                      color: "var(--text-muted)",
                      opacity: 0.5,
                    }}
                  ></i>
                )}
              </div>
            );
          })
        ) : (
          <div
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              color: "var(--text-muted)",
            }}
          >
            <i
              className="bi bi-search"
              style={{ fontSize: 24, marginBottom: 8, opacity: 0.2 }}
            ></i>
            Məlumat tapılmadı
          </div>
        )}
      </div>

      <style>{`
        @keyframes pulse { 0% { opacity: 1; } 50% { opacity: 0.5; } 100% { opacity: 1; } }
        .list-item-hover:hover { background: rgba(37,99,235,0.05) !important; padding-left: 20px !important; transition: all 0.2s; }
        .modern-select:focus { border-color: var(--color-primary) !important; outline: none; }
        .custom-scrollbar::-webkit-scrollbar { width: 4px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: var(--border); border-radius: 10px; }
      `}</style>
    </div>
  );
}
